import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: arnoldlepineux
 * id C633DDA7-FB93-4041-98C2-92117B970114
 * name tray-arrow-up
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tray-arrow-up.svg
 * tags
 * - Arrow 
 */
export const TrayArrowUpIcon = createSvgIcon(<><path d="M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12M12 2L6.46 7.46L7.88 8.88L11 5.75V15H13V5.75L16.13 8.88L17.55 7.45L12 2Z" /></>, 'TrayArrowUpIcon');
export default TrayArrowUpIcon